module.exports = function ($timeout, loadingIndicator) {
    return {
        restrict: 'E',
        link(scope) {
            scope.loading = loadingIndicator;

            let loadingIndicatorTimeout;

            scope.$on('ajaxNavigationStart', function () {
                // Cancel the timeout if it has been started
                if (loadingIndicatorTimeout) {
                    $timeout.cancel(loadingIndicatorTimeout);
                }

                loadingIndicatorTimeout = $timeout(function () {
                    loadingIndicator.startLoading();
                }, 500);
            });

            scope.$on('ajaxNavigationSuccess', function () {
                $timeout.cancel(loadingIndicatorTimeout);
                loadingIndicator.finishLoading();
            });
        },
        template: '<wow-loading-spinner ng-if="loading._isLoading" class="loadingIndicator-spinner"></wow-loading-spinner><div ng-if="loading._isMasked" class="loadingIndicator-mask"></div>'
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/loadingindicator/loading-indicator-directive.js
 **/